module.exports = __webpack_public_path__ + "img/undraw_social_girl_562b.f177f2fb.svg";